export const LOAD_MODELS = "LOAD_MODELS";
export const LOAD_MODELS_SUCCESS = "LOAD_MODELS_SUCCESS";
export const LOAD_MODELS_ERROR = "LOAD_MODELS_ERROR";
